<div class="button-config-panel admin-theme" @fadeSlideInOut style="position: absolute;">

    <ng-container [ngSwitch]="config.type">
        <mat-form-field>
            <mat-label>Button-Aktion:</mat-label>
            <mat-select [(ngModel)]="config.type" (selectionChange)="onTypeChange()" panelClass="admin-theme">
                @for(actionType of actionTypes; track $index) {
                  <mat-option [value]="actionType">{{ displayNames[actionType] }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <!-- ScrollTo -->
        @if (isScrollToParams(config.params)) {
        <mat-form-field *ngSwitchCase="ButtonActionType.ScrollTo">
          <mat-label>Ziel:</mat-label>
            <mat-select
            [(ngModel)]="config.params.target"
            (ngModelChange)="validateAndSave()"
            panelClass="admin-theme">
                @for(component of allCurrentComponents$(); track $index) {
                <mat-option [value]="component">
                    {{ component }}
                </mat-option>
            }
            </mat-select>
        </mat-form-field>
        }
      
        <!-- Navigate -->
        @if (isNavigateParams(config.params)) {
        <mat-form-field *ngSwitchCase="ButtonActionType.Navigate">
          <mat-label>Seitenname:</mat-label>
          <mat-select
            [(ngModel)]="config.params.url"
            (ngModelChange)="validateAndSave()"
            panelClass="admin-theme">
                @for(page of allPages$(); track $index) {
                <mat-option [value]="page.url">
                   {{ page.name }}
                </mat-option>
            }
          </mat-select>
        </mat-form-field>
        }

        <!-- ScrollAndNavigate -->
        @if (isNavigateAndScrollToParams(config.params)) {
          <mat-form-field *ngSwitchCase="ButtonActionType.NavigateAndScrollTo">
            <mat-label>Seitenname:</mat-label>
            <mat-select
              [(ngModel)]="config.params.url"
              (ngModelChange)="onPageChange($event)"
              panelClass="admin-theme">
                  @for(page of allPages$(); track page.url) {
                  <mat-option [value]="page.url">
                    {{ page.name }}
                  </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Zu Komponente scrollen:</mat-label>
            <mat-select
              [(ngModel)]="config.params.target"
              (ngModelChange)="validateAndSave()"
              panelClass="admin-theme">
              
              @if (targetComponents$().length > 0) {
                @for(compId of targetComponents$(); track compId) {
                  <mat-option [value]="compId">{{ compId }}</mat-option>
                }
              } @else {
                <mat-option disabled>Keine Ziele auf dieser Seite gefunden</mat-option>
              }
              
            </mat-select>
            <mat-hint v-if="!config.params.url">Wähle erst eine Seite aus</mat-hint>
          </mat-form-field>
        }

        <!-- ExternalLink -->
        @if (isExternalLinkParams(config.params)) {
        <mat-form-field *ngSwitchCase="ButtonActionType.ExternalLink">
          <mat-label>Externer Link (URL):</mat-label>
          <input
            matInput
            [(ngModel)]="config.params.url"
            (ngModelChange)="validateAndSave()"
            placeholder="https://example.com" />
        </mat-form-field>
        }
      </ng-container>
      
    <button (click)="close()">Schließen</button>
</div>